import { BodyRegular, FlexColMdFitContent, FlexMdAlignCenter } from 'components/Elements';
import { LearnerLearningObjective } from 'models/LearnerCourse';
import ValidateIcon from 'assets/icons/indicators/ValidateIcon';
import { PaddedCardFitContent } from 'pages/learner/sharedStyles/LearnerStyles';

type LearningObjectivesCardProps = {
    learningObjectives: LearnerLearningObjective[];
};

export default function LearningObjectivesCard({ learningObjectives }: LearningObjectivesCardProps) {
    return (
        <PaddedCardFitContent>
            <FlexColMdFitContent>
                {learningObjectives
                    .sort((a, b) => a.order - b.order)
                    .map((x) => (
                        <FlexMdAlignCenter key={x.id}>
                            <ValidateIcon />
                            <BodyRegular>{x.description}</BodyRegular>
                        </FlexMdAlignCenter>
                    ))}
            </FlexColMdFitContent>
        </PaddedCardFitContent>
    );
}
